// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__39sLO","sendOtp":"AuthorizeToLogin_sendOtp__2x-Fi"};